export default __webpack_public_path__ + "static/media/Rotbolter.24c4f357.jpg";